<template>
  <solution-sheet-item :title="$t('Travamentos')">
    <solution-sheet-item-span-restraints-sub-item-fibre-upper
      :upper-fibre-value="spanRestraints.upperFibre"
    />
    <solution-sheet-item-span-restraints-sub-item-fibre-lower
      :lower-fibre-value="spanRestraints.lowerFibre"
    />
  </solution-sheet-item>
</template>

<script>
import {
  SolutionSheetItem,
  SolutionSheetItemSpanRestraintsSubItemFibreLower,
  SolutionSheetItemSpanRestraintsSubItemFibreUpper,
} from "@/components";

export default {
  components: {
    SolutionSheetItem,
    SolutionSheetItemSpanRestraintsSubItemFibreLower,
    SolutionSheetItemSpanRestraintsSubItemFibreUpper,
  },
  props: {
    spanRestraints: {
      required: true,
      type: Object,
    },
  },
};
</script>